import React from 'react'
import QrCode from 'qrcode.react'

export const createQrCode = (): string => {
	let str = 'ST00012'

	const requisites = {
		Name: 'КПК "ФОНД ИПОТЕЧНОГО КРЕДИТОВАНИЯ"',
		PersonalAcc: '40701810516540000382',
		BankName: 'УРАЛЬСКИЙ БАНК ПАО СБЕРБАНК',
		BIC: '046577674',
		CorrespAcc: '30101810500000000674',
		KPP: '668501001',
		PayeeINN: '6678102434',
		OrgName: 'КПК ФОНД ИПОТЕЧНОГО КРЕДИТОВАНИЯ"',
		OrgNumber: '651303465003905',
		sum: `${50 * 100}`,
		ContactPhone: '88007758009',
		Purpose: 'Оплата обязательного паевого взноса в КПК "Фонд ипотечного кредитования"',
		Rules: 'https://credit.club/rules',
		Site: 'https://credit.club/',
		NPMIR: 'http://www.npmir.ru/',
		CBR: 'http://www.cbr.ru/',
		LK: 'https://lk.credit.club/',
		FSSPRUS: 'http://fssprus.ru/',
	}

	Object.keys(requisites).forEach((key) => {
		if (requisites[key as keyof typeof requisites]) {
			str += `|${key}=${requisites[key as keyof typeof requisites]}`
		}
	})

	return str
}

export const QR = ({ size }: { size: number }) => (
	<QrCode value={createQrCode()} size={size} renderAs='svg' />
)
